export default ({ instance, baseURL, headers}) => {
    const apiCalls = {        
        recuperarTermo(){
            return instance({
                method: 'get',
                baseURL,
                url: 'Termo/RecuperarTermo',
                responseType: 'json',
                headers: headers,
                //data: null,
            });
        },
    }
    return apiCalls;
}